import styled from 'styled-components';

export const ToggleBtn = styled.button`
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  cursor: pointer;
  border-radius: 999px;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
  color: ${(props) => (props.$onDark ? 'rgba(242, 246, 243, 0.8)' : 'var(--cp-text-secondary, #5b6770)')};
  background: ${(props) => (props.$onDark ? 'rgba(255, 255, 255, 0.08)' : 'var(--cp-surface-alt, #fafbfc)')};
  border: 1px solid ${(props) => (props.$onDark ? 'rgba(255, 255, 255, 0.12)' : 'var(--cp-border, #e5e7eb)')};

  svg {
    width: 17px;
    height: 17px;
  }

  &:hover {
    color: var(--cp-green, #47b972);
    border-color: var(--cp-green, #47b972);
  }
`;
